import { render, staticRenderFns } from "./StudentOverview.vue?vue&type=template&id=46d66546&"
import script from "./StudentOverview.ts?vue&type=script&lang=ts&"
export * from "./StudentOverview.ts?vue&type=script&lang=ts&"
import style0 from "./StudentOverview.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports